import { BaseDisplayer } from './BaseDisplayer';
import { ValueType } from '../FormatterTypes';
import { asBoolean } from '../Utils/ValueUtils';
import { formatterStrParamDef } from '../Utils/ParamUtils';

class TEDDisplayBool extends BaseDisplayer {
  public static getInstance() {
    return this.instance ? this.instance : (this.instance = new this());
  }

  private static instance: TEDDisplayBool;

  defaultParams(): string {
    return `TrueText="Ja";FalseText="Nej";NullText=""`;
  }

  display(
    value: ValueType,
    displayText: boolean = true,
    params: string = ''
  ): string {
    let result = '';
    if (value !== undefined && value !== null) {
      const vb = asBoolean(value);
      if (vb === null) {
        result = formatterStrParamDef('NullText', params, this.defaultParams());
      } else if (vb) {
        result = formatterStrParamDef('TrueText', params, this.defaultParams());
      } else {
        result = formatterStrParamDef(
          'FalseText',
          params,
          this.defaultParams()
        );
      }
    } else {
      const falseText = formatterStrParamDef(
        'FalseText',
        params,
        this.defaultParams()
      );
      if (falseText === '') {
        result = formatterStrParamDef('NullText', params, this.defaultParams());
      } else {
        result = formatterStrParamDef(
          'FalseText',
          params,
          this.defaultParams()
        );
      }
    }

    return result;
  }

  defaultDisplayLength(params: string): number {
    return Math.max(
      ...[
        formatterStrParamDef('TrueText', params).length,
        formatterStrParamDef('FalseText', params).length,
        formatterStrParamDef('NullText', params).length,
      ]
    );
  }
}

export { TEDDisplayBool };
